import React, { FC, memo } from "react";

import { Container, ContainerChart, ContainerLegend, ContainerAlias, ContainerValue } from "./styled";
import { ExpandableTitle } from "../components/ExpandableTitle/ExpandableTitle";
import { DataSourceError } from "../components/DataSourceError/DataSourceError";
import { useChartData } from "../hooks/useChartData";
import { ContainerProps } from "../types";

export const ChartContainer: FC<ContainerProps> = memo(
  ({ config, elementConfig, isVisible, attributes, type, renderElement }) => {
    const { options, children } = elementConfig || {};
    const { twoColumns, hideEmpty } = options || {};

    const chartElement = children.find(({ id }) => id === "chart");
    const isStackBar = chartElement.options.chartType === "stack";

    const { data, loading } = useChartData({
      config,
      element: chartElement,
      attributes,
      type,
    });

    if (data[0] && !data[0]?.items) {
      return <DataSourceError name={elementConfig.templateName} />;
    }

    const hasItems = !!data[0]?.items?.length;

    if (!loading && !hasItems && hideEmpty) return null;

    return (
      <>
        <ExpandableTitle elementConfig={elementConfig} type={type} renderElement={renderElement} />
        {isVisible && (
          <Container>
            {!isStackBar && <ContainerAlias hasBottomMargin>{renderElement({ id: "alias" })}</ContainerAlias>}
            <ContainerValue column={!twoColumns} center>
              {hasItems ? (
                <>
                  <ContainerChart>{renderElement({ id: "chart" })}</ContainerChart>
                  <ContainerLegend>{renderElement({ id: "legend" })}</ContainerLegend>
                </>
              ) : (
                <>&mdash;</>
              )}
            </ContainerValue>
          </Container>
        )}
      </>
    );
  },
);
